<template>
    <div>
        <el-card shadow="hover">
            <div slot="header" class="px-1">
                <h6 class="text-center m-0">{{ cardtitle }}</h6>
            </div>
            <div class="text-center mb-4" v-if="false">
                <el-radio-group size="small" v-model="viewtype" type="button">
                    <el-radio-button :label="'ytd'">YTD</el-radio-button>
                    <el-radio-button :label="'current'">CUR</el-radio-button>
                </el-radio-group>
            </div>
            <PieChart class="mt-0" :data="this.chartdata" :url="''" style="width:100%;" :showlegend="false"/>
            <Loader v-if="loading.chart" />
        </el-card>
    </div>  
</template>


<script>
import Finance from '@/components/page/Finance.js'
//import PieChart from '@/components/chart/Pie.js'
import PieChart from '@/components/chart/Doughnut.js'
import BarChart from '@/components/chart/BarChart.js'
//import LineChart from '@/components/chart/LineChart.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, AppColorsGradient, Config, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

//
export default {
    extends: Finance,
    components:{ 
        PieChart,
        Loader,
        //BarChart,
        //LineChart,
     },
    props: {
        title: {
            type: String,
            default: 'PIECHART',
            //required: false,
        },
        area: {
            type: String,
            default: '',
            //required: false,
        },
        year: {
            type: Number,
            default: Penanggalan().tahun,
            //required: false,
        },
        month: {
            type: Number,
            default: Penanggalan().bulan,
            //required: false,
        },
        status :{
            type: String,
            default: '',
            //required: false,
        },
        charttypedefault :{
            type: String,
            default: 'piechart',
            //required: false,
        },
        unitids: {
            type: Array,
            default() {
                return [];
            }
        },
        costcenters: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    setup() {
        
    },
    mounted() {
        //this.setCashNonCashData()
        this.getData()
    },
    data() {
        return {
            cardtitle: this.title, //'STATUS BY SALES AREA',
            viewtype: 'ytd', //'piechart',
            stacked: false,
            chartdata: [],
            maindata: [],
            barchart: [],
            loading : {
                table: true,
                chart: true,
            }
        }
    }, 
    watch : {
        stacked() {
            this.setBarchart();
        },
        area(newVal, oldVal) {
            this.getData();
            //console.log('Area changed from', oldVal, 'to', newVal);
        },
        year(newVal, oldVal) {
            this.getData();
            //console.log('Year changed from', oldVal, 'to', newVal);
        },
        month(newVal, oldVal) {
            this.getData();
            //console.log('Month changed from', oldVal, 'to', newVal);
        },
        costcenters(newVal, oldVal) {
            this.getData();
            //console.log('Month changed from', oldVal, 'to', newVal);
        },
    },
    methods: {
        async getData() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/plunit/jumlahunitoperasi?'

			//this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0] : '')
			//this.urlRequestParams+='&date-range-end='+ (this.dateRange && this.dateRange[1] ? this.dateRange[1] : '')
			this.urlRequestParams+='&status='+this.status
			this.urlRequestParams+='&area='+this.area
            this.urlRequestParams+='&year='+this.year
			this.urlRequestParams+='&month='+this.month
            this.urlRequestParams+='&costcenters='+this.costcenters //all unit

			this.loading.table = true;
			this.loading.chart = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					//let chartdata = response.data.data.chart_data;
                    this.maindata = response.data.data.unit_operasi.chart_data;
					this.cardtitle = response.data.data.unit_operasi.title.toUpperCase();
                    this.setPiecharthData(this.maindata);
                    //console.log('response ' + JSON.stringify(response.data.data.chart_data));
                })
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.chart = false;
					this.loading.table = false;
				})

        },

        setPiecharthData(data) {
			let item = data //CashPosition;
			//console.log('item pieChartData:' + JSON.stringify(item))
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].Label] = AppColorsGradient[idx]; //AppColors[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].Label, 
                    amount: item[row].Value,
                };

                value.push(main);
                idx++;
            }

            this.chartdata = this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },
    }
}
</script>

<style>
.el-card__header {
    padding: 12px 10px;
}
</style>